import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { WarningIcon } from 'components/Shared/Icons/Icons';
import { breakpoints, colors } from 'styles/cp';

export interface Props {
  // eslint-disable-next-line no-unused-vars
  signInCallback: (e: any) => void;
  cancelCallback: () => void;
  isUserSignedIn?: boolean;
  isSignedInUserTheScheduler?: boolean;
  isAutoPay?: boolean;
  isSubscription?: boolean;
}

const ScheduleInvoiceAction: React.FC<Props> = ({
  isUserSignedIn = false,
  isSignedInUserTheScheduler = false,
  signInCallback,
  cancelCallback,
  isAutoPay = false,
  isSubscription = false,
}) => {
  let action;

  if (!isUserSignedIn) {
    let toCancelMsg;
    if (isSubscription) {
      toCancelMsg = (
        <FormattedMessage
          id="TO_CANCEL_THIS_SUBSCRIPTION"
          defaultMessage="To cancel this subscription, "
        />
      );
    } else if (isAutoPay) {
      toCancelMsg = (
        <FormattedMessage id="TO_CANCEL_AUTOPAY" defaultMessage="To cancel autopay, " />
      );
    } else {
      toCancelMsg = (
        <FormattedMessage id="TO_CANCEL_THIS_PAYMENT" defaultMessage="To cancel this payment, " />
      );
    }

    action = (
      <Fragment>
        <div className="to-cancel">
          {toCancelMsg}
          &nbsp;
          <div
            className="sign-in"
            onClick={signInCallback}
            data-cy="schedule-invoice-action-link-sign-in"
          >
            <FormattedMessage id="SIGN_IN" defaultMessage="sign in" />
          </div>
        </div>

        <style jsx>{`
          .to-cancel {
            display: inline-flex;
            font-family: AvenirNextforINTUIT-Medium;
            font-size: 14px;

            @media screen and (max-width: ${breakpoints.md}) {
              font-family: AvenirNextforINTUIT-Regular;
            }

            .sign-in {
              display: inline-block;
              color: ${colors.blue};
              cursor: pointer;
            }
          }
        `}</style>
      </Fragment>
    );
  } else if (isSignedInUserTheScheduler) {
    let toCancelMsg;
    if (isSubscription) {
      toCancelMsg = (
        <FormattedMessage id="CANCEL_SUBSCRIPTION" defaultMessage="Cancel recurring payment" />
      );
    } else if (isAutoPay) {
      toCancelMsg = <FormattedMessage id="CANCEL_AUTOPAY" defaultMessage="Cancel autopay" />;
    } else {
      toCancelMsg = (
        <FormattedMessage id="CANCEL_THE_PAYMENT" defaultMessage="Cancel this payment" />
      );
    }
    action = (
      <Fragment>
        <div
          className="cancel-payment"
          onClick={cancelCallback}
          data-cy="schedule-invoice-action-cancel-payment"
        >
          {toCancelMsg}
        </div>

        <style jsx>{`
          .cancel-payment {
            cursor: pointer;
            display: inline-flex;
            color: ${colors.blue};
            font-family: AvenirNextforINTUIT-Medium;
            font-size: 14px;
          }
        `}</style>
      </Fragment>
    );
  } else {
    action = (
      <Fragment>
        <div className="scheduled-by-someone-else">
          <span className="warning">
            <WarningIcon width={20} height={20} color={colors.gray} />
          </span>
          {!isAutoPay ? (
            <FormattedMessage
              id="SCHEDULED_BY_SOMEONE_ELSE"
              defaultMessage="This payment has been scheduled by someone else"
            />
          ) : (
            <FormattedMessage
              id="SUBSCRIPTION_BY_SOMEONE_ELSE"
              defaultMessage="Another recipient of this invoice has set up autopay."
            />
          )}
        </div>

        <style jsx>{`
          .scheduled-by-someone-else {
            color: ${colors.gray02};
            font-family: AvenirNextforINTUIT-Regular;
            font-size: 14px;
            display: flex;
            justify-items: center;

            .warning {
              padding: 0 5px;
            }
          }
        `}</style>
      </Fragment>
    );
  }

  return action;
};

export default ScheduleInvoiceAction;
